import { gigNegotiationsList } from '@/services/jobs/gigNegotiations.service'

export default {
	namespaced: true,
	state: {
		list: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		listStatus: 'pending',
	},
	getters: {
		getList(state)       { return state.list },
		getListStatus(state) { return state.listStatus },
	},
	mutations: {
		SET_LIST(state, value)        { state.list = value },
		SET_LIST_STATUS(state, value) { state.listStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await gigNegotiationsList(params)
				commit('SET_LIST_STATUS', 'init')
				commit('SET_LIST', data)
				return data
			} catch (error) {
				commit('SET_LIST_STATUS', 'init')
				throw error
			}
		},
	},
}
